export const model = {
  deleteInformation:
    "要删除设备型号“{0}”，请为列表中的设备指定其他设备型号，或者删除。(如果删除设备，系统将被注销并停止发送数据。）",
  deleteNoUsedTip: "设备型号“{0}”将被删除。确定要继续吗？",
  deleteUsedTip: "确认删除设备型号“{0}”并应用更改？",
  deleteVehicle: "删除设备",
  editModel: "编辑型号",
  failedToSaveModelNameAlreadyExist: "保存失败，此型号已存在。",
  modelDetails: "型号详情",
  newModel: "新建型号",
  pleaseInputMake: "请输入设备品牌",
  pleaseInputModelName: "请输入型号名称",
  pleaseSelectDriveTrainType: "请选择工作等级",
  selectVehicleModel: "请选择设备型号",
  vehicleList: "设备列表",
  vehicleModelDeletion: "删除设备型号",
};
